import { HTTP } from "@/api";
import moment from "moment";

export default {
  countForecasts({ commit }, range) {
    commit("isLoading", {
      key: "forecasts",
      status: true
    });
    Object.keys(range).forEach(key => {
      // eslint-disable-next-line fp/no-mutation
      range[key] = moment(range[key]).format("YYYY-MM-DD");
    });
    return HTTP.get(
      `/live/forecast_counter?start=${range.startDate}&end=${range.endDate}`
    )
      .then(res => {
        if (res.data && res.data.success)
          commit("countForecasts", res.data.result);
      })
      .finally(() =>
        commit("isLoading", {
          key: "forecasts",
          status: false
        })
      );
  }
};
